import { z } from './utils/zod.js';
import { listResponse, successResponse } from './utils/response-templates.js';
import { planCodeSchema, planIntervalSchema } from './pricing-catalogue.js';
export const organizationSurveyDtoSchema = z.object({
    numOfSigPerMonth: z.string().optional(),
    teamSize: z.string().optional(),
    typeOfSig: z.enum(['Simple', 'Advanced', 'Qualified', 'Notarized', "I don't know"]).optional(),
    videoConf: z.string().optional(),
    about: z.string().optional().openapi({ example: 'A description of the organization' }),
});
export const organizationDtoSchema = z.object({
    id: z.string(),
    createdAt: z.string(),
    updatedAt: z.string(),
    ownerId: z.string(),
    name: z.string(),
    country: z.string(),
    taxId: z.string().nullable(),
    language: z.string(),
    survey: organizationSurveyDtoSchema.nullable(),
    customerType: z.enum(['BUSINESS', 'CONSUMER']),
    planCode: planCodeSchema,
    planInterval: planIntervalSchema.nullable(),
    pendingPlanInterval: planIntervalSchema.nullable(),
    billingExempt: z.boolean(),
    cancelAt: z.string().datetime().nullable(),
    // Populated only by `organization.me` (the Team page reads it from there). Other
    // endpoints that return an OrganizationDto leave these undefined to avoid extra
    // queries when the caller doesn't need seat info.
    seatsUsed: z.number().int().nonnegative().optional(),
    // null = unlimited
    seatLimit: z.number().int().nonnegative().nullable().optional(),
});
export const createOrganizationRequestSchema = z.object({
    name: z.string().optional().openapi({ example: 'swipesign xu' }),
    country: z.string().min(1).openapi({ example: 'es' }),
    taxId: z
        .string()
        // .regex(/^[A-Z]{2}[0-9]{5,}$/) - This is problematic in supported countries
        .nullable()
        .openapi({ example: 'EE123456789' }),
    language: z.string().optional().openapi({ example: 'en' }),
    survey: organizationSurveyDtoSchema.optional().openapi({ example: {} }),
});
export const organizationUpdateRequestSchema = createOrganizationRequestSchema.partial();
const accountTypePersonalSchema = z.object({
    type: z.literal('personal'),
    country: z.string().min(1).openapi({ example: 'es' }),
});
const accountTypeCompanySchema = z.object({
    type: z.literal('company'),
    country: z.string().min(1).openapi({ example: 'es' }),
    companyName: z.string().trim().min(1).openapi({ example: 'swipesign xu' }),
    taxId: z.string().trim().min(1).nullable().optional().openapi({ example: 'EE123456789' }),
});
export const setAccountTypeRequestSchema = z.discriminatedUnion('type', [
    accountTypePersonalSchema,
    accountTypeCompanySchema,
]);
export const setAccountTypeResponseSchema = successResponse().extend({
    data: organizationDtoSchema,
});
export const createOrganizationResponseSchema = successResponse().extend({
    token: z.string(),
    data: organizationDtoSchema,
});
export const organizationUpdateResponseSchema = successResponse().extend({
    data: organizationDtoSchema,
});
export const organizationResponseSchema = organizationDtoSchema;
export const organizationMemberSchema = z.object({
    id: z.string(),
    status: z.enum(['ACTIVE', 'SUSPENDED', 'INVITED', 'EXPIRED']),
    type: z.enum(['user', 'invitation']),
    name: z.string().optional(),
    email: z.string().email(),
    role: z.string().optional(),
});
export const organizationGetMembersResponseSchema = listResponse(organizationMemberSchema);
